import { createTheme } from '@material-ui/core/styles';

export default createTheme({
  palette: {
    type: 'light',
    primary: {
      // light: "#0066ff",
      main: '#da291c',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: "#616161"
    },
    secondary: {
      main: '#da291c',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: "#616161"
    },
    error: {
      // light: "#0066ff",
      main: '#da291c',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: "#616161"
    },
  },
  overrides: {
    MuiFilledInput: {
      // Name of the component ⚛️ / style sheet
      root: {
        backgroundColor: '#F6F6F6',
      },
    },
    // RaToolbar: {
    //   toolbar: {
    //     borderTop: '1px solid #cccccc',
    //   },
    // },
    MuiTableCell: {
      sizeSmall: {
        padding: 5,
      },
    },
    MuiDialogContent: {
      root: {
        padding: '8px 10px',
      },
    },
    RaFormInput: {
      input: {
        width: 'unset',
      },
    },
    MuiCardContent: {
      root: {
        padding: '12px',
        paddingBottom: 0,
        '&:last-child': {
          paddingBottom: 0,
        },
      },
    },
    MuiCardHeader: {
      root: {
        padding: '12px',
        paddingBottom: 0,
      },
    },
  },
});
